import { Grid, styled, Switch, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { ColorFilterElement } from '../styles';

interface ColorFilterProps {
  negativeLabel?: string;
  positiveLabel?: string;
}

export const ColorLabelContainer = styled(Typography)(({ theme }) => ({
  marginRight: theme.spacing(2.5),
  '&:nth-child(2)': {
    marginRight: 0,
  },
}));

export const Row = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(2.5),
  '&:last-child': {
    marginBottom: 0,
  },
}));

const Toggle = withStyles((theme) => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: 'inline-flex',
  },
  switchBase: {
    padding: 2,
    color: theme.palette.common.white,
    '&$checked': {
      transform: 'translateX(12px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: 'none',
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.54)',
  },
  checked: {},
}))(Switch);

const ColorFilter = ({
  negativeLabel = 'Biased',
  positiveLabel = 'Unbiased',
}: ColorFilterProps) => (
  <>
    <Row item container>
      <ColorLabelContainer variant='caption'>
        <ColorFilterElement /> {positiveLabel}
      </ColorLabelContainer>
      <ColorLabelContainer variant='caption'>
        <ColorFilterElement className='Negative' /> {negativeLabel}
      </ColorLabelContainer>
    </Row>
    <Row item container justifyContent='space-between' alignItems='center'>
      <Typography variant='caption'>Only show racially biased</Typography>
      <Toggle />
    </Row>
  </>
);

export default ColorFilter;
